// AI-generated report fields don't reliably come back as arrays — the same
// field can be a proper array, a single object, a bare string, or missing
// entirely depending on what the model produced. Checking `?.length > 0` is
// not enough to guard a `.map()` call since strings have `.length` too and
// don't have `.map` — normalize to an array first, always.
export const toArray = value => {
  if (Array.isArray(value)) return value
  if (value == null) return []
  return [value]
}

// AI-generated prose (action descriptions, revenue trend blurbs, "why this
// estimate" text, etc.) often embeds raw numbers straight from the source
// data — a 13-decimal rating average, a 7-digit download count with no comma
// grouping. Rewrite only the numbers that actually need cleanup (long
// integers, long decimals); leave small numbers, years, and percentages
// (anything immediately followed by "%") untouched.
export const formatNumbersInText = text => {
  if (typeof text !== "string") return text
  return text.replace(/\$?\d+(?:\.\d+)?/g, (match, offset, full) => {
    if (full[offset + match.length] === "%") return match
    const hasDollar = match.startsWith("$")
    const raw = hasDollar ? match.slice(1) : match
    const [intPart, decPart] = raw.split(".")
    const trimmedInt = intPart.replace(/^0+(?=\d)/, "")
    const needsGrouping = trimmedInt.length >= 5
    const needsRounding = !!decPart && decPart.length > 2
    if (!needsGrouping && !needsRounding) return match
    const num = Number(raw)
    if (!Number.isFinite(num)) return match
    const formatted = num.toLocaleString(undefined, { maximumFractionDigits: 2 })
    return hasDollar ? `$${formatted}` : formatted
  })
}

// A responsive CSS grid column-width: min() keeps the requested minimum from
// ever forcing horizontal overflow on viewports narrower than that minimum
// (e.g. a `minmax(320px, 1fr)` track on a 300px-wide phone would otherwise
// overflow the page). Use as: `repeat(auto-fit, ${fit(320)})`.
export const fit = px => `minmax(min(${px}px, 100%), 1fr)`
